import Icon from '../components/Icon.vue'

Icon.register({
  th: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M149.3 56v80c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24zM330.7 296c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24v80zM362.7 56c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80zM330.7 136c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24v80zM125.3 192c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h101.3zM0 376c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80zM386.7 320c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-101.3zM386.7 480c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-101.3zM181.3 376c0-13.3 10.7-24 24-24h101.3c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-101.3c-13.3 0-24-10.7-24-24v-80z'
      }
    ]
  }
})
